"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreatureStrip = CreatureStrip;
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const useStyles_1 = require("~/useStyles");
const creatureImage_1 = require("../ui/creatureImage");
const useStyles = (0, useStyles_1.createUseThemeStyles)(() => ({
    strip: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: "0.5rem",
    },
    creature: {
        width: "48px",
        height: "48px",
    },
}));
/** Decorative row of creature sprites. */
function CreatureStrip({ definitionIds, className, }) {
    const classes = useStyles();
    return (React.createElement("div", { className: (0, classnames_1.default)(classes.strip, className) }, definitionIds.map((id) => (React.createElement("div", { key: id, className: classes.creature },
        React.createElement(creatureImage_1.CreatureImage, { definitionId: id, facing: "front" }))))));
}
